/**
 * Dynamic shipping calculation based on site configuration
 * @param {Object} shipping - The shipping config object from Firestore
 * @param {Array} cartItems - Current items in cart
 * @param {Number} subtotal - Cart subtotal
 * @returns {Object} - { cost: Number, label: String }
 */
export function calcShipping(shipping, cartItems, subtotal) {
    if (!shipping) return { cost: 0, label: "Shipping" };
    
    // Only count physical items for shipping calculation
    const physicalItems = (cartItems || []).filter(i => !i.isDigital);
    const totalPhysicalQty = physicalItems.reduce((s, i) => s + i.quantity, 0);

    if (totalPhysicalQty === 0) return { cost: 0, label: "Free Shipping (Digital)" };
    if (shipping.mode === "free") return { cost: 0, label: "Free Shipping" };

    // Free threshold
    if (shipping.freeShippingEnabled && parseFloat(shipping.freeThreshold) > 0 && subtotal >= parseFloat(shipping.freeThreshold)) {
        return { cost: 0, label: `Free (over $${shipping.freeThreshold})` };
    }

    if (shipping.mode === "flat") return { cost: parseFloat(shipping.flatRate) || 0, label: "Standard Shipping" };

    if (shipping.mode === "perBook") {
        const rate = totalPhysicalQty === 1
            ? parseFloat(shipping.oneBookRate) || 0
            : parseFloat(shipping.twoPlusRate) || 0;
        return { cost: rate, label: "Standard Shipping" };
    }
    return { cost: 0, label: "Shipping" };
}

/**
 * Legacy/Simple calculation helper for CartDrawer
 * (Updated to potentially take settings)
 */
export function calculateOrderTotal(items, shippingSettings = null) {
    const subtotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    
    let shipping = 0;
    let shippingLabel = "Shipping";

    if (shippingSettings) {
        const res = calcShipping(shippingSettings, items, subtotal);
        shipping = res.cost;
        shippingLabel = res.label;
    } else {
        // Fallback to old logic if no settings provided yet
        const physicalBooks = items.filter(i => !i.isDigital).reduce((sum, i) => sum + i.quantity, 0);
        if (physicalBooks > 0) {
            shipping = physicalBooks === 1 ? 4.75 : 10.0;
        }
    }

    const tax = 0; 
    return { subtotal, shipping, shippingLabel, tax, total: subtotal + shipping };
}